import { useMemo } from "react";
import {
  isMoreThan24HoursAgo,
  formatScheduleEventRange,
} from "../../../helpers";
import { useScheduleEventStore, usePatientSurgeryStore } from "../../hooks";
import { SecondaryButton, MainButton } from "../../ui";
import { PROCEDURE_IDS } from "../../data";

export const ProcedureEventsCard = ({
  handleSelectEventToReschedule,
  handleViewMediaModal,
}) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,
  } = usePatientSurgeryStore();

  const {
    // Props
    scheduleEvents,
  } = useScheduleEventStore();

  const { id: procedureParentId } = patientSurgery.data.procedure.procedure;

  // States ------------------------------------------------//
  const filteredEvents = useMemo(() => {
    return scheduleEvents.filter(
      (event) => event.type === "TEST_PROCEDURE" || event.type === "PROCEDURE"
    );
  }, [scheduleEvents]);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <>
      {filteredEvents.length === 0 && (
        <div className="d-flex align-items-center">
          <p className="mb-0">No tienes sesiones agendadas</p>
          {PROCEDURE_IDS.CORE === procedureParentId && (
            <SecondaryButton
              className="ms-auto"
              onClick={() => handleViewMediaModal()}
            >
              Revisar recomendaciones
            </SecondaryButton>
          )}
        </div>
      )}

      {filteredEvents.length > 0 && (
        <div className="d-flex align-items-center">
          <h5 className="mb-0">Tus sesiones agendadas</h5>
          <SecondaryButton
            className="ms-auto"
            onClick={() => handleViewMediaModal()}
          >
            Revisar recomendaciones
          </SecondaryButton>
        </div>
      )}

      {filteredEvents.map((scheduleEvent, index) => (
        <div key={scheduleEvent.id} className="card border">
          <div className="card-body">
            <div className="vstack gap-3">
              <h5 className="mb-0">
                Sesión {index + 1} (
                {formatScheduleEventRange(
                  scheduleEvent.start,
                  scheduleEvent.end
                )}
                )
              </h5>
              <p className="mb-0">
                <b>Título: </b>
                {scheduleEvent.title}
              </p>
              <p className="text-break mb-0">
                <b>Ubicación: </b>
                {scheduleEvent.notes}
              </p>
              {scheduleEvent.attended !== null && (
                <p className="mb-0">
                  <b>Asistencia: </b>
                  {scheduleEvent.attended ? "Asistió" : "No asistió"}
                </p>
              )}
              {scheduleEvent.attended === null && (
                <div>
                  <MainButton
                    type="button"
                    disabled={isMoreThan24HoursAgo(scheduleEvent.start)}
                    onClick={() => {
                      handleSelectEventToReschedule(scheduleEvent);
                    }}
                  >
                    Reagendar
                  </MainButton>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
